import React, { useContext, useState } from 'react';
import { useForm } from "react-hook-form";
import { API, Auth } from 'aws-amplify';
import { XMarkIcon } from '@heroicons/react/24/outline'
import AppContext from '../AppContext';


const UserUpdateForm = ({data, refreshData}) => {
  const { closeModal } = useContext(AppContext);
  const [role, setRole] = useState(data.user_group);
  const [firstName, setFirstName] = useState(data.first_name);
  const [lastName, setLastName] = useState(data.last_name);
  const [email] = useState(data.email);
  const [enabledUser, setEnabledUser] = useState(data.enabled)
  const [working, setWorking] = useState(false);

  const { register, formState: { errors }, handleSubmit, setValue, trigger } = useForm();


  const updateUser = async () => {
    try {
        setWorking(true)
        const myInit = {
            response: true,
            headers: { Authorization: `${(await Auth.currentSession()).getIdToken().getJwtToken()}` },
            body: {
                "userEmail": email,
                "userEnabled": enabledUser,
                "role": role,
                "firstName": firstName,
                "lastName": lastName
            }
          };
          // console.log('myinit ', myInit)

          // const response = 
          await API.post('APIEndpoint', `/update-user`, myInit) 
     
        // setToast('Success!', `${props?.email} was successfully updated!`, true);
        refreshData && refreshData();
        setWorking(false);
        closeModal();
    } catch(error) {
        setWorking(false);
        console.log(error);
        // setToast('Failure!', `${props?.email} was not updated!`, false);
    }
  };

  const handleValidationChange = (name, value) => {
    setValue(name, value);
    trigger(name);
  }


  return (
    <div className="bg-white p-8 rounded-md">
    <form onSubmit={handleSubmit(updateUser)}>
        <div className="flex justify-between items-stretch">
          <h2 className="text-base font-semibold leading-7 text-othergray-900 self-center">Update User</h2>
          {/* <p className="mt-1 text-sm leading-6 text-othergray-600">Update {data.email} info for {selectedClientName}.</p> */}
          <button className="cursor-pointer" onClick={closeModal}><XMarkIcon className="w-8 h-8 rounded-full hover:stroke-primary-600"/></button>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 border-t border-othergray-900/10 pt-6">
            <div className="sm:col-span-3">
              <label htmlFor="first-name" className="block text-sm font-medium leading-6 text-othergray-900">
                First name
              </label>
              <div className="mt-2">
                <input
                  {...register("firstName", { required: "First Name is required" })}
                  type="text"
                  name="firstName"
                  id="firstName"
                  autoComplete="none"
                  aria-invalid={errors?.firstName ? "true" : "false"} 
                  value={firstName}
                  // placeholder='Enter First Name'
                  onChange={(e) => {setFirstName(e.target.value); handleValidationChange(e.target.name, e.target.value)}}
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 placeholder:text-othergray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  {/* <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" /> */}
                </div>
                {!!errors?.firstName && <p className="mt-2 text-sm text-red-600" id="firstNameError">
                  {errors?.firstName?.message}
                </p>}
              </div>
            </div>

            <div className="sm:col-span-3">
              <label htmlFor="last-name" className="block text-sm font-medium leading-6 text-othergray-900">
                Last name
              </label>
              <div className="mt-2">
                <input
                  {...register("lastName", { required: "Last Name is required" })}
                  type="text"
                  id="lastName"
                  name='lastName'
                  autoComplete='none'
                  label='Last Name'
                  value={lastName}
                  aria-invalid={errors?.lastName ? "true" : "false"} 
                  // placeholder='Enter Last Name'
                  onChange={(e) => {setLastName(e.target.value); handleValidationChange(e.target.name, e.target.value)}}
                  className="block w-full rounded-md border-0 py-1.5 text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 placeholder:text-othergray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
                />
              </div>
              {!!errors?.lastName && <p className="mt-2 text-sm text-red-600" id="lastNameError">
                  {errors?.lastName?.message}
                </p>}
            </div>

            <div className="sm:col-span-3">
              <label htmlFor="enabledUser" className="block text-sm font-medium leading-6 text-othergray-900">
              Enable User
              </label>
              <div className="flex h-30 align-center py-3">
              <input
                      id="enabledUser"
                      name="enabledUser"
                      type="checkbox"
                      checked={enabledUser}
                      onChange={(e)=> setEnabledUser(e.target?.checked)}
                      className="h-6 w-6 rounded border-othergray-300 text-primary-600 focus:ring-primary-600 cursor-pointer focus:hover:bg-primary-400"
                    />
              </div>
            </div>

            

            <div className="sm:col-span-3">
              <label htmlFor="user-role" className="block text-sm font-medium leading-6 text-othergray-900">
                User Role
              </label>
              <div className="mt-2">
                <select
                  {...register("userRole", { required: 'Role is required', minLength: 1 })}
                  id="userRole"
                  placeholder='Select User Role'
                  value={role}
                  aria-invalid={errors?.userRole ? "true" : "false"} 
                  onChange={(e) => {setRole(e.target?.value); handleValidationChange(e.target?.name, e.target?.value)
                  }}
                  name='userRole'
                  className="block w-full rounded-md border-0 py-1.5 cursor-pointer text-othergray-900 shadow-sm ring-1 ring-inset ring-othergray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:max-w-xs sm:text-sm sm:leading-6"
                >
                  <>
                    <option key='' value='' disabled={true} ></option>
                    <option key='ADMIN' value='ADMIN'>ADMIN</option>
                    <option key='USER' value='USER'>USER</option>
                  </>
                </select>
              </div>
            </div>
            <div className="sm:col-start-2 sm:col-end-7 mt-6 flex items-center justify-between sm:justify-end gap-x-6">
              <button 
                type="button" 
                className="bg-othergray-200 font-semibold text-othergray-900 px-3 py-2 rounded-md text-sm font-semibold shadow-sm hover:bg-othergray-400 hover:text-white"
                onClick={closeModal}
                disabled={working}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-200 disabled:bg-primary-200 focus-visible:outline-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                disabled={working}
              >
                Update User
              </button>
          </div>
        </div>
      </form>
      </div>
  );
};

export default UserUpdateForm;